import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import "./DataSourceDonut.css";

// Register chart components
ChartJS.register(ArcElement, Tooltip, Legend);

export default function DataSourceDonut({ dataSourceData }) {
  const chartData = {
    labels: dataSourceData.map((d) => d.name),
    datasets: [
      {
        data: dataSourceData.map((d) => d.value),
        backgroundColor: dataSourceData.map((d) => d.color),
        borderWidth: 2,
        borderColor: "#ffffff",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "60%",
    layout: {
      padding: {
        bottom: 20,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div className="donut-container">
      <div style={{ width: "100%", height: "200px" }}>
        <Doughnut data={chartData} options={chartOptions} />
      </div>
      <ul className="custom-legend">
        {dataSourceData.map((item, index) => (
          <li key={index} style={{ color: item.color }}>
            <span className="legend-color" style={{ backgroundColor: item.color }}></span>
            {item.name}
          </li>
        ))}
      </ul>
    </div>
  );
}
